$('.clp-resources-hero').slick({
    dots: true
});



// WEBPACK FOOTER //
// ./src/app/components/clp-resources-hero/clp.resources.hero.js